// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__QGr2g","detailsBorder":"styles_detailsBorder__1Vxu0"};